import { MarginDirectiveType } from '../../directives/margin/MarginDirective.type.tsx';
import { PdfVisibilityDirectiveType } from '../../directives/pdf-visibility/PdfVisibilityDirective.type.tsx';
import { WidgetDirectivesRepository } from '../../directives/WidgetDirectivesRepository.ts';
import { getAllWidgetTypes } from './getAllWidgetTypes.tsx';
import { WidgetRepository } from './WidgetRepository.ts';

/**
 * Soluzione per evitare di eseguire il codice di inizializzazione manualmente
 * in ogni metodo della classe.
 * Non possiamo eseguirlo direttamente nel costruttore per via delle dipendenze
 * circolari.
 */
export function initWidgetRepository() {
  if (WidgetRepository.isInitialized) {
    return;
  }

  getAllWidgetTypes().forEach(type => WidgetRepository.register(type));
  WidgetRepository.isInitialized = true;

  /**
   *  DIRETTIVE
   */

  /**
   * Visibilità del campo in compilazione/pdf
   */
  WidgetDirectivesRepository.register(PdfVisibilityDirectiveType);
  /**
   * Margine
   */
  WidgetDirectivesRepository.register(MarginDirectiveType);
}
